module.exports = __webpack_public_path__ + "static/img/image_error.896718f.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/chat/components/image_error.png
// module id = mSxY
// module chunks = 1